import { __BLUEBELL_ATOMIC__, BLUEBELL_ATOMIC_VERSION } from './constant';

import { createGlobalFactory } from './utils/createGlobalFactory';
import { promiseIgnoreCatch } from './utils/promiseIgnoreCatch';

class Atomic {
    static #instance: Atomic;

    #processingPromise: Promise<unknown> | null = null;

    private constructor() {
        // super();
        /* istanbul ignore if: difficult to enter */
        if (Atomic.#instance) {
            throw Error('UmdExportResolver cannot be created more than once.');
        }
    }

    public get version(): number {
        return BLUEBELL_ATOMIC_VERSION;
    }

    public static getInstance(): Atomic {
        if (!Atomic.#instance) {
            Atomic.#instance = new Atomic();
        }

        return Atomic.#instance;
    }

    public commit<T = unknown>(promise: Promise<T>): Promise<T> {
        if (this.#processingPromise) {
            return promiseIgnoreCatch(this.#processingPromise).then(() => promise);
        }

        const p: Promise<T> = Promise.resolve()
            .then(() => promise)
            .finally(() => {
                this.#processingPromise = null;
            });

        this.#processingPromise = p;

        return p;
    }
}

export type { Atomic };

export const getAtomic = createGlobalFactory<Atomic>(
    __BLUEBELL_ATOMIC__,
    () => Atomic.getInstance(),
    BLUEBELL_ATOMIC_VERSION,
    // Conflict is better than throwing error.
    true
);
